import { ConfigSetting, ConfigSettingType } from '@homeflow/v4-lib/sections';

/**
 * BOH property tags, the tags themselves never change only the date label shown for each one
 * which is set in the admin on /admin/ui/search-form.
 */
export const OPEN_HOUSE_TAGS = [
  { tag: 'day 1', key: 'openHouseDay1Label' },
  { tag: 'day 2', key: 'openHouseDay2Label' },
  { tag: 'day 3', key: 'openHouseDay3Label' },
  { tag: 'weekend 1', key: 'openHouseWeekend1Label' },
] as const;

const extraSearchFormSettings: ConfigSetting[] = OPEN_HOUSE_TAGS.map(({ tag, key }) => ({
  label: `Open House — "${tag}" date`,
  description: `Date shown for properties tagged '${tag}'.`,
  type: ConfigSettingType.Text,
  defaultValue: '',
  field: `searchForm.extraSettings.${key}`,
}));

export default extraSearchFormSettings;
